import ACCESS_ENUM from "@/access/accessEnum";

/**
 * 权限检查函数
 * @param loginUser 当前登录用户信息
 * @param needAccess 访问所需权限，默认为不需要登录
 * @returns 是否有访问权限
 */
const checkAccess = (loginUser: any, needAccess = ACCESS_ENUM.NOT_LOGIN) => {
  const loginUserAccess = loginUser?.userRole ?? ACCESS_ENUM.NOT_LOGIN;
  if (needAccess === ACCESS_ENUM.NOT_LOGIN) {
    return true;
  }
  if (needAccess === ACCESS_ENUM.USER) {
    if (loginUserAccess === ACCESS_ENUM.NOT_LOGIN) {
      return false; // 需要登录但未登录
    }
  }
  if (needAccess === ACCESS_ENUM.ADMIN) {
    if (loginUserAccess !== ACCESS_ENUM.ADMIN) {
      return false; // 需要管理员权限但用户不是管理员
    }
  }
  return true; // 其他情况都允许访问
};

export default checkAccess;
